export const getSpritemap = (): string => {
    const spritemap = Liferay.Icons?.spritemap;
    if (spritemap) {
        return spritemap;
    }
    return `${Liferay.ThemeDisplay.getPathThemeImages()}/clay/icons.svg`;
};
